/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { topicsList } from "../../funcs/topicsList.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$topicsList: ToolDefinition = {
  name: "topics-list",
  description: `List Available Topics

Returns a list of available event topics configured in the Outpost instance.`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await topicsList(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
